export const DEFAULT_HERO_IMAGE = 'https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&q=80';

export const getHeroSlides = (settings = {}) => {
  try {
    const savedSlides = JSON.parse(settings.hero_slides);
    if (Array.isArray(savedSlides)) {
      const images = savedSlides
        .filter((url) => typeof url === 'string' && /^(https?:\/\/|\/uploads\/)/i.test(url.trim()))
        .map((url) => url.trim())
        .slice(0, 5);

      if (images.length > 0) return images;
    }
  } catch {
    // Existing sites have only hero_image, not hero_slides.
  }

  return [settings.hero_image || DEFAULT_HERO_IMAGE];
};
